import { FC, useEffect } from "react";
import HeroSection from "./HeroSection";
import CurrentVacanciesSection from "./CurrentVacanciesSection";
import HowItWorksSection from "./HowItWorksSection";
import MarketRatesSection from "./MarketRatesSection";
import CallToSubscribeSection from "./CallToSubscribeSection";
import ReviewsSection from "./ReviewsSection";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { PlatformInfoServiceImpl } from "../../../services/PlatformInfoServiceImpl";
import { WorksStatisticServiceImpl } from "../../../services/WorksStatisticServiceImpl";

const MainPage: FC = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        (async () => {
            await Promise.all([
                dispatch(PlatformInfoServiceImpl.getPlatformInfoThunk()),
                dispatch(WorksStatisticServiceImpl.getYearStatisticThunk()),
            ]);
        })();
    }, []);

    return (
        <>
            <HeroSection />
            <CurrentVacanciesSection />
            <HowItWorksSection />
            <MarketRatesSection />
            <CallToSubscribeSection />
            <ReviewsSection />
        </>
    );
};

export default MainPage;
